import styled from 'styled-components';

export const TableContainer = styled.div`
  /* padding: var(--padding-lg); */
`;
